import store from "../store/index"
import { decrypt, asyncTask, getCookie, findAllRects, changeRectIds, isFieldAllEmpty, smartMathMax } from "utils"
import { reverseBuildModel, reverseBuildModelForApp, reverseBuildModelForBigScreen } from "utils/reverseBuildModel.js"
import { fixComponent } from "utils/analysisTypeId.js"
import { data_dictionary_map, data_dictionary_map_new } from "root/static/dataDictionary.js"
import instance from "../interceptor"
import { event } from "utils/event"
import { jsonCompressEncode } from "utils/jsonCompress"
import { v1 } from "uuid"
import Vue from "vue"
import { getHtmlPlainText, simpleDeepClone, handleWebjsonBeforeInit } from "@/utils"
import api from "api"
import { getWebsiteSubHeadPageId } from "@/utils/refHead"
// 初始化路由数据
/**
 * @returns
 */
export async function initUrlQueryData(checkPcVersion) {
  //格式化url的query
  const urlQuery = GetRequest()
  console.log("urlQuery", urlQuery)
  let { w, p, pageId, websiteId, e, t, d, a, hp, noswiper, searchKey, pv, swiper, name, hasEqualPage, ehp } = urlQuery
  w = w || websiteId
  p = p || pageId
  const param = {}
  await initGetCookie()
  let myCookie = store.state.states.myCookie
  console.log("myCookie", myCookie)
  let wfwfid = myCookie.website_fid
  param.wfwfid = wfwfid ? wfwfid : "65692"
  param.engineInstanceId = e
  param.typeId = t
  param.dataId = d
  param.appId = a
  param.homePageId = hp
  param.noswiper = noswiper
  param.searchKey = searchKey
  param.swiper = swiper
  param.name = name
  param.hasEqualPage = hasEqualPage
  param.formId = null
  hasEqualPage ? param.equalHomePageId = ehp : ""
  if (pv) {
    param.pv = pv
  }else {
    //解决pv未定义的问题 Cannot read properties of undefined (reading 'pv')
    param.pv = ""
  }
  if (w && p) {
    Object.keys(urlQuery).forEach(item => {
      if (item === "p") {
        param.pageId = urlQuery[item]
      } else if (item === "w") {
        param.websiteId = urlQuery[item]
      }
    })
    // 根据localStorage中的参数判断当前页面类型
    localStorage.removeItem("detailData")
    if(a) {
      try {
        const res = await api.getContentConfig({ appId: a, engineType: "general" })
        const formId = res.data.data.config.divUrlParams.split('formId=')[1]?.split('&')[0];
        param.formId = formId
      } catch(e) {
        console.log("非表单数据源")
      }
    }
    store.commit("states/updateDataPageIds", param)
  } else {
    param.sign = "92e29c58b56735a1492183d1fb7281a5"
    if(a) {
      try {
        const res = await api.getContentConfig({ appId: a, engineType: "general" })
        const formId = res.data.data.config.divUrlParams.split('formId=')[1]?.split('&')[0];
        param.formId = formId
      } catch(e) {
        console.log("非表单数据源")
      }
    }
    store.commit("states/updateDataPageIds", param)
  }
  //初始化跨页面传参
  if (localStorage.getItem("pageQuery")) {
    const pageQuery = localStorage.getItem("pageQuery") || ""
    localStorage.removeItem("pageQuery")
    const uuid = v1()
    window.pageQueryUid = uuid
    sessionStorage.setItem(uuid, pageQuery)
  }

  await initStageData(param, checkPcVersion)
  await initUserRole()
  // 获取机器人数据
  const robotList = await getRobotList()
  if (robotList?.data?.data) {
    sessionStorage.setItem("robotList", JSON.stringify(robotList.data.data))
  }
  if (Vue.prototype.request_prefix === "appStage" && !urlQuery?.isSubHeadPage) {
    setTimeout(() => {
      judgeSyncData()
    }, 1000)
  }
}

export async function initStageData(param, checkPcVersion) {
  const { pageId } = param
  console.log("param", param)
  if (!pageId) {
    console.log("缺少pageId")
    return
  }
  let needInitPcStageData = true
  /* 是否是 子页面判断 */
  if(param.homePageId && param.homePageId !== pageId){
    /* 纯移动端判断
     * 根据首页是否是纯移动端来判断子页面 */
    let res = await judgeIsMobile(param.homePageId)
    if(res.data && res.data.code === 1 && (res.data.data.isPhoneFullScreen || res.data.data.isOnlyH5Template)){
      needInitPcStageData = false
    }
  }
  if(needInitPcStageData){
    await initPcStageData(pageId, param, checkPcVersion) //原因是移动端页面刷新之后  在同步  就会同步空数据
  }
  if (!checkPcVersion) {
    await initAppStageData(pageId, param)
  }
}

/**
 * 初始化pc端数据
 */
export async function initPcStageData(pageId, param, checkPcVersion, onlyHandleData) {
  let data = null
  const { pv, appId } = param
  const pageType = pv === "1" ? "listPage" : "detailPage"
  const stage = localStorage.getItem("subPageSetting-" + appId + "-stage")
  const subPage = JSON.parse(stage || "{}")
  if (pv && subPage && subPage[`${pageType}IsUseSystemTemplate`]) {
    const templateId = subPage[`${pageType}TemplateId`]
    let res
    if (sessionStorage.getItem("changingSubPageTemplate")) {
      res = await api.queryComponentContentClone({
        encId: templateId,
        p: param.pageId,
        ct: 1
      })
    }else{
      res = await getSubTemplateContent(templateId)
    }
    if (res.data.data) {
      data = {
        content: JSON.stringify({
          event: {},
          page: JSON.parse(res.data.data.content),
          template_v2_mh: 1,
          type: pageType,
          version: 1
        })
      }
    }
  } else {
    const res = await getPageData(pageId, 0, undefined, 7)
    data = res.data.data
  }
  //判断是否有模板
  if (data) {
    const webJsonRel = data?.webJsonRel
    let stage = JSON.parse(data?.content)
    if (!stage) {
      localStorage.setItem("useLocalTemplate", "true")
      return
    }
    if (stage.hasOwnProperty("data") && stage.hasOwnProperty("templates")) {
      // 如果content下面有data、template属性，说明是新数据，需要进行解密
      stage = jsonCompressEncode(stage)
    }
    if (!stage.hasOwnProperty("page")) return // 如果没有page属性，说明是纯移动端模版，pc端不需要初始化
    const version = parseInt(stage.version)
    if (webJsonRel?.subPages && webJsonRel.subPages != "[]") {
      // 如果在外面取到了subPages，则还原回stage.page.subPages里面去
      if (stage.page) {
        const relSubPages = JSON.parse(webJsonRel.subPages).map(item =>
          decrypt(JSON.stringify(item), stage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)
        )
        stage.page.subPages = stage.page?.isSubHeadPage ? compareSubPages(relSubPages, stage.page.subPages) : relSubPages
      }
    }
    //从页面管理列表跳转过来的平级页面判断
    if(sessionStorage.getItem("isEqualPage")){
      sessionStorage.removeItem("isEqualPage")
      stage.type = "equalPage"
    }
    if (stage?.page?.subHeadPageId) {
      const originPageId = (stage?.page?.subHeadPages ?? []).find(item => item.headPageId === stage?.page?.subHeadPageId)?.originPageId
      if (originPageId !== param.pageId) {
        // 说明是从模板拿过来的二级头数据, 这个时候不能用要丢掉
        stage.page.subHeadPageId = ''
        stage.page.subHeadPages = []
        stage.page.enableSubHead = false
      }
    }
    if (stage.type === "bigScreen") {
      stage = decrypt(JSON.stringify(stage), stage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)
      if (stage.hasOwnProperty("version") && stage.version === 0) {
        return
      }
      reverseBuildModelForBigScreen(stage)
      handleWebjsonBeforeInit(stage)
      store.dispatch("bigScreen/initWebJson", stage)
    } else if (stage.type === "normal" || stage.type === "stage" || stage.page?.isPhoneFullScreen) {
      // 如果需要执行PC版本检测，并且服务端取回的数据的版本号和store里面的版本一致，则认为不需要重新执行initWebJson
      if (checkPcVersion && store?.state?.stage?.version && stage.version === store?.state?.stage?.version) return
      console.time("优化前深拷贝")
      stage = decrypt(JSON.stringify(stage), stage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)
      console.timeEnd("优化前深拷贝")
      if (stage.hasOwnProperty("version") && version === 0) {
        return
      }
      reverseBuildModel(stage)
      // 针对旧数据没得containerId的做兼容
      stage.page.children.forEach((child, index) => {
        if (!child.hasOwnProperty("container_id")) {
          child.container_id = index
        }
      })
      handleWebjsonBeforeInit(stage)
      if (!onlyHandleData) {
        store.dispatch("stage/initWebJson", stage)
      }
    } else if (stage.type === "listPage" || stage.type === "detailPage" || stage.type === "equalPage") {
      // 当前页面为子页面
      stage = await handleSubPageData(stage, param, 0)
      handleWebjsonBeforeInit(stage)
      if (!onlyHandleData) {
        store.dispatch("stage/initWebJson", stage)
      }
    }
    event.init(stage.event ? stage.event : {}, "stage")
    if (document.getElementsByName("editPage").length > 0) {
      document.getElementsByClassName("loading-box")[0].style.display = "none"
    }
    if (onlyHandleData) {
      return stage
    }
  } else {
    //没模板 用默认数据
    console.log("useLocalTemplate")
    localStorage.setItem("useLocalTemplate", "true")
    return null
  }
}

/**
 * 初始化移动端数据
 */
export async function initAppStageData(pageId, param = {}, onlyHandleData) {
  let data = null
  const { pv, appId } = param
  const pageType = pv === "1" ? "listPage" : "detailPage"
  const stage = localStorage.getItem("subPageSetting-" + appId + "-appStage")
  const subPage = JSON.parse(stage || "{}")
  if (pv && subPage && subPage[`${pageType}IsUseSystemTemplate`]) {
    const templateId = subPage[`${pageType}TemplateId`]
    let res
    if (sessionStorage.getItem("changingSubPageTemplate")) {
      res = await api.queryComponentContentClone({
        encId: templateId,
        p: param.pageId,
        ct: 1
      })
    }else{
      res = await getSubTemplateContent(templateId)
    }
    if (res.data.data) {
      // 移动端没有内容，直接用pc端的
      const content = res.data.data.appContent === "{}" ? res.data.data.content : res.data.data.appContent
      data = {
        content: JSON.stringify({
          event: {},
          page: JSON.parse(content),
          template_v2_mh: 1,
          type: pageType,
          version: 1
        })
      }
    }
  } else {
    const res = await getPageData(pageId, 1, undefined, 7)
    data = res.data.data
  }
  if (data) {
    const webJsonRel = data?.webJsonRel
    let appStage = JSON.parse(data?.content)
    if (appStage.hasOwnProperty("data") && appStage.hasOwnProperty("templates")) {
      // 如果没有version属性，说明是新数据，需要进行解密
      appStage = jsonCompressEncode(appStage)
    }
    if (webJsonRel?.appSubPages  &&  webJsonRel.appSubPages != "[]") {
      // 如果在外面取到了subPages，则还原回stage.page.subPages里面去
      if (appStage.page) {
        const relSubPages = JSON.parse(webJsonRel.appSubPages).map(item =>
          decrypt(JSON.stringify(item), appStage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)
        )
        appStage.page.subPages = appStage.page?.isSubHeadPage ? compareSubPages(relSubPages, appStage.page.subPages) : relSubPages
      }
    }
    parseInt(appStage.version)
    console.log("appStage.type", appStage.type)
    //从页面管理列表跳转过来的平级页面判断
    if(sessionStorage.getItem("isEqualPage")){
      sessionStorage.removeItem("isEqualPage")
      appStage.type = "equalPage"
    }
    if (appStage?.page?.subHeadPageId) {
      const originPageId = (appStage?.page?.subHeadPages ?? []).find(item => item.headPageId === appStage?.page?.subHeadPageId)?.originPageId
      if (originPageId !== param.pageId) {
        // 说明是从模板拿过来的二级头数据, 这个时候不能用要丢掉
        appStage.page.subHeadPageId = ''
        appStage.page.subHeadPages = []
        appStage.page.enableSubHead = false
      }
    }
    // 子页面不具备 isPhoneFullScreen 模式，所以可以不处理
    if (
      appStage.type === "normal" ||
      appStage.type === "stage" ||
      appStage.type === "h5" ||
      appStage.page?.isPhoneFullScreen
    ) {
      appStage = decrypt(JSON.stringify(appStage), appStage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)
      if (appStage.page.children.length > 0) {
        appStage.page.children[0].isActive = true
      }
      reverseBuildModelForApp(appStage)
    } else if (appStage.type === "listPage" || appStage.type === "detailPage" || appStage.type === "equalPage") {
      appStage = await handleSubPageData(appStage, param, 1)
      if (appStage.type !== "equalPage") {
        const subHeadPageId = await getWebsiteSubHeadPageId(1)
        if (subHeadPageId) {
          appStage.page.useSubHead = true
          appStage.page.subHeadPageId = subHeadPageId
        }
      }
    }
    handleWebjsonBeforeInit(appStage, true)
    if (!onlyHandleData) {
      store.dispatch("appStage/initWebJson", appStage)
      event.init(appStage.event ? appStage.event : {}, "appStage")
    }

    if (document.getElementsByName("editPage").length > 0 || document.getElementsByName("html-container").length > 0) {
      document.getElementsByClassName("loading-box")[0].style.display = "none"
    }
    return appStage
  } else {
    //没模板 用默认数据
    console.log("useLocalTemplate")
    localStorage.setItem("useLocalTemplate", "true")
  }
}

export function compareSubPages(newSubPages, oldSubPages) {
  if (!oldSubPages?.length) return newSubPages
  const subPages = []
  newSubPages?.forEach(item => {
    if (subPages.findIndex(subItem => subItem.appId === item.appId) == -1) {
      subPages.push(item)
    }
  })
  oldSubPages?.forEach(item => {
    const index = subPages.findIndex(subItem => subItem.appId === item.i0)
    if (index == -1) {
      subPages.push(item)
    }
  })
  return simpleDeepClone(subPages)
}

/**
 * 处理子页面的数据
 * @param {*} stage
 * @param {*} appId
 * @param {*} homePageId
 * @returns
 */
async function handleSubPageData(stage, param, pageType) {
  let _stage = JSON.parse(JSON.stringify(stage))
  // 默认改为undefined 因为预览页undefined 是当做true来处理的
  let useRefNav
  const { engineInstanceId, typeId, dataId, appId, websiteId, wfwfid } = param
  let { homePageId } = param
  if (!homePageId) {
    // 因为平级页面的子页面此时取的是平级页面的pageId,无法实时更新首页的头底
    homePageId = window.sessionStorage.getItem("homePageId")
    // window.sessionStorage.removeItem("homePageId")
    // 保留吧，免得刷新页面就没有了
  }
  const homePageRes = await getPageData(homePageId, pageType, undefined, 7)
  if (homePageRes.data.data?.content) {
    // 暂时屏蔽调 && _stage.page，因为会导致后面针对没有page属性的数据无法进行处理
    let homeStage = JSON.parse(homePageRes.data.data?.content)
    if (homeStage.hasOwnProperty("data") && homeStage.hasOwnProperty("templates")) {
      // 如果没有version属性，说明是新数据，需要进行解密
      homeStage = jsonCompressEncode(homeStage)
    }
    const homeWebJsonRel = homePageRes.data.data?.webJsonRel
    if (
      (homeWebJsonRel?.subPages && homeWebJsonRel.subPages != "[]") ||
      (homeWebJsonRel?.appSubPages && homeWebJsonRel.appSubPages != "[]")
    ) {
      homeStage.page &&
        (homeStage.page.subPages = JSON.parse(
          (pageType === 0 ? homeWebJsonRel.subPages : homeWebJsonRel.appSubPages) || "[]"
        ).map(item => decrypt(JSON.stringify(item), homeStage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)))
    }
    homeStage = decrypt(JSON.stringify(homeStage), homeStage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)
    if (pageType === 0) {
      reverseBuildModel(homeStage)
    } else {
      reverseBuildModelForApp(homeStage)
    }
    _stage = decrypt(JSON.stringify(_stage), _stage.encryptFlag ? data_dictionary_map_new : data_dictionary_map)
    if (pageType === 0) {
      reverseBuildModel(_stage)
    } else {
      reverseBuildModelForApp(_stage)
    }
    // 获取首页中的该子页面的配置项
    if (_stage.type === "listPage" || _stage.type === "detailPage") {
      if (sessionStorage.getItem("changingSubPageTemplate")) {
        sessionStorage.removeItem("changingSubPageTemplate")
      } else {
        // 说明子页面自己在编辑，此时子页面关系没有同步到到首页，直接取本地值
        if(sessionStorage.getItem("isJumpingSubPage")) {
          sessionStorage.removeItem("isJumpingSubPage")
        } else {
          const request_prefix = pageType === 1 ? "appStage" : "stage"
          const subPage = getSubPageData(appId, homeStage)
          console.log("subPage", homeStage, subPage)
          if (subPage) {
            localStorage.setItem("subPageSetting-" + appId + "-" + request_prefix, JSON.stringify(subPage))
          }
        }
      }
    }
    // _stage.subPageSetting = subPageSetting
    // 脏数据兼容，后面会用到该属性，需要提前初始化
    if (!_stage.hasOwnProperty("page")) {
      // 针对该种类型的脏数据，直接使用当前首页的children
      _stage.page = homeStage.page
      // 需要去掉pageLayoutList、children
      _stage.page.pageLayoutList = []
      _stage.page.children[0].children = []
    }
    // 二级页面引用首页头部相关通栏
    let refHomeHeaderAttachment  = false
    const headerLayout = _stage.page.pageLayoutList.find(item=>item.options.inDocument === 'header')
    if(headerLayout){
      refHomeHeaderAttachment = headerLayout.options.isRefHomeOther
    }
    // 查看当前二级页面的头底是否存在，如果存在则使用当前页面的头底
    const hasHeader = _stage.page.pageLayoutList.find(item => item.options.inDocument === "header")
    /** 如果没有头，那么一定会引用头  */
    if (!hasHeader && _stage.type !== "equalPage") {
      const subHeadPageId = await getWebsiteSubHeadPageId(pageType)
      if (subHeadPageId) {
        _stage.page.useSubHead = true
        _stage.page.subHeadPageId = subHeadPageId
      } else {
        _stage.page.useSubHead = false
        _stage.page.subHeadPageId = null
      }
    }
    if (_stage.page.pageLayoutList.length > 0) {
      for (let i = 0, flag = true, len = _stage.page.pageLayoutList.length; i < len; flag ? i++ : i) {
        const item = _stage.page.pageLayoutList[i]
        if (!item) break
        const refHomeTypes = refHomeHeaderAttachment ? ['header','relativeHeader','headerOther','footer'] : ['header','footer']
        // 清理当前头底的同时，也需要清理头底中的组件
        // if (item.options.inDocument === "header" || item.options.inDocument === "footer") {
        if (refHomeTypes.indexOf(item.options.inDocument) !== -1) {
          // 清理头部脏数据
          if (i > 0 && item.options.inDocument === "header") {
            _stage.page.pageLayoutList.splice(i, 1)
            const oldRectIds = findAllRects(item)
            oldRectIds.forEach(rectId => {
              const index = _stage.page.children[0].children.findIndex(child => child.rect_id === rectId)
              if (index > -1) {
                _stage.page.children[0].children.splice(index, 1)
              }
            })
          }
          // 是子页面，并且开了头部引用
          if (_stage.type !== "equalPage" && (item.options.isRefHome === undefined || item.options.isRefHome) && item.options.inDocument === "header") {
            const subHeadPageId = await getWebsiteSubHeadPageId(pageType)
            if (subHeadPageId) {
              _stage.page.useSubHead = true
              _stage.page.subHeadPageId = subHeadPageId
            } else {
              _stage.page.useSubHead = false
              _stage.page.subHeadPageId = null
            }
          }
          // 该处需要进行老数据兼容，如果没有isRefHome属性，则默认为true
          if (item.options.isRefHome === undefined || item.options.isRefHome) {
            flag = false
            if (item.options.isRefHome && item.options.inDocument === "header" && item.options.isRefNav) {
              // 平级页面的子页面也需求同步首页导航
              useRefNav = true
            }
            _stage.page.pageLayoutList.splice(i, 1)
            const oldRectIds = findAllRects(item)
            oldRectIds.forEach(rectId => {
              const index = _stage.page.children[0].children.findIndex(child => child.rect_id === rectId)
              if (index > -1) {
                _stage.page.children[0].children.splice(index, 1)
              }
            })
          } else {
            flag = true
          }
        } else {
          flag = true
          // 没有头底通栏时
          _stage.page.isShowHeader = false
          _stage.page.isShowFooter = false
        }
      }
    }
    const useSubHead = _stage.page.useSubHead
    if (useSubHead) {
      const subHeadStage = await parsePageData(_stage.page.subHeadPageId, pageType)
      console.log(`subHeadStage数据`, subHeadStage)
      subHeadStage.page.children[0]?.children.forEach(item => {
        item.options.inSubHead = undefined
      })
      const originRelativeHeadLayoutIndex = _stage.page.pageLayoutList.findIndex(item => item.options.inDocument === "relativeHeader")
      const currentRelativeHeadLayoutIndex = subHeadStage.page.pageLayoutList.findIndex(item => item.options.inDocument === "relativeHeader")
      if (currentRelativeHeadLayoutIndex !== -1 && originRelativeHeadLayoutIndex !== -1) {
        _stage.page.pageLayoutList.splice(originRelativeHeadLayoutIndex, 1)
      }
      const subHeadDrawerLayouts = subHeadStage.page.pageLayoutList.filter(item => item.options.inDocument === "drawer")
      if (subHeadDrawerLayouts?.length) {
        // 看哈原始数据里面是否有同名的抽屉，如果有，把原来的那个删掉
        subHeadDrawerLayouts.forEach(layout => {
          const originIndex = _stage.page.pageLayoutList.findIndex(item => item.options.source_id === layout.options.source_id)
          if (originIndex !== -1) {
            _stage.page.pageLayoutList = _stage.page.pageLayoutList.filter(item => item.options?.source_id !== layout.options.source_id)
          }
        })
      }
      _stage.page.pageLayoutList.unshift(...subHeadStage.page.pageLayoutList)
      // 不能直接push，否则children里面会越来越多
      const subHeadStageRectIds = [...new Set(subHeadStage.page.children[0].children.map(item => item.rect_id))]
      _stage.page.children[0].children = _stage.page.children[0].children.filter(item => !subHeadStageRectIds.includes(item.rect_id))
      _stage.page.children[0].children.push(...subHeadStage.page.children[0].children)
      _stage.page.subPages = (_stage.page.subPages || []).concat(...subHeadStage.page.subPages)
    }
    // 在布局模式中找到头底通栏，并引用首页的头底通栏，同时需要找出通栏中的组件，将其添加到当前页面
    if (homeStage.page.pageLayoutList) {
      homeStage.page.pageLayoutList.forEach(item => {
        const refHomeTypes = useSubHead ? ['footer'] : (refHomeHeaderAttachment ? ['header','relativeHeader','headerOther','footer']:['header','footer'])
        if (refHomeTypes.indexOf(item.options.inDocument) !== -1 ) {
          let flag = false // 用于标识当前页面是否已经需要添加头或者底
          // 该处需要获取当前页面的头底通栏，如果没有isRefHome属性，则默认为true
          const currentStageItem = _stage.page.pageLayoutList.find(
            it => it.options.inDocument === item.options.inDocument
          )
          // 说明当前页面没有头底通栏，直接将首页的头底通栏添加到当前页面
          if (!currentStageItem) {
            flag = true
          } else {
            flag = currentStageItem.options.isRefHome
          }
          if (flag) {
            // 子页面引用首页头，底，去掉通栏的定位(就是改成默认相对定位)
            //  需求变更，平级页面保留头部的定位，子页面不保留定位
            if(_stage.type === "listPage" || _stage.type === "detailPage"){
              item.options.positionType = "relative"
            }
            item.options.isRefHome = flag
            item.options.isRefNav = useRefNav
            console.log("item",item)
            const rectIds = findAllRects(item)
            const oldRectIds = []
            let newRectIds = []
            let rectInPageLayoutComponent=[]
            // 根据rectId找到对应的组件，将其添加到当前页面
            rectIds.forEach(rectId => {
              oldRectIds.push(rectId)
              let componentTemp = getComponentByRectId(homeStage, rectId)
              if (componentTemp && componentTemp.shape === "cxPageLayoutComponent") {
                const tmpRects = findAllRects(componentTemp.options.layout)
                for (let i in tmpRects) {
                  oldRectIds.push(tmpRects[i])
                  rectInPageLayoutComponent.push(tmpRects[i])
                }
              }
            })
            oldRectIds.forEach(rectId => {
              let componentTemp = getComponentByRectId(homeStage, rectId)
              if (componentTemp) {
                if (!_stage.page.children || _stage.page.children.length === 0) return
                const component = JSON.parse(JSON.stringify(componentTemp))
                const allRects = _stage.page.children[0].children
                let _rect_id = -1
                if (allRects.length > 0) {
                  _rect_id = smartMathMax(
                    ...allRects.map(function (o) {
                      return o.rect_id
                    })
                  )
                }
                // 需要同步更新头部的headComponentMap中的rectId
                if (item.options.headComponentMap) {
                  for (let key of Object.keys(item.options.headComponentMap)) {
                    if (item.options.headComponentMap[key] === rectId) {
                      item.options.headComponentMap[key] = _rect_id + 1
                    }
                  }
                }
                newRectIds.push(_rect_id + 1)
                component.rect_id = _rect_id + 1
                changeRectInAnimation(component, rectId, _rect_id + 1)
                _stage.page.children[0].children.push(component)
              } else {
                //  changeRectIds 方法里面是根据indexof 来取的对应关系，所以不存在也要加入
                newRectIds.push(undefined)
              }
            })
            changeRectIds(item, oldRectIds, newRectIds)
            newRectIds.forEach(rectId => {
              let index =  _stage.page.children[0].children.findIndex(child => child.rect_id === rectId)
              let componentTemp = getComponentByRectId(_stage, rectId)
              if (componentTemp && componentTemp.shape === "cxPageLayoutComponent") {
                changeRectIds(componentTemp.options.layout, oldRectIds, newRectIds)
                if(index>-1){
                  _stage.page.children[0].children.splice(index,1,componentTemp)
                }
              } else if(componentTemp && componentTemp.shape === "cxTabs"){
                let parentRectId = componentTemp.options.parentRectId
                let oldParentIdIndex = oldRectIds.findIndex(item=>item === parentRectId)
                if(oldParentIdIndex > -1){
                  componentTemp.options.parentRectId = newRectIds[oldParentIdIndex]
                  _stage.page.children[0].children.splice(index,1,componentTemp)
                }
              }
            })
            //  删除脏数据
            for (let k = 0; k < _stage.page.pageLayoutList.length; k++) {
              if (
                _stage.page.pageLayoutList[k].options &&
                _stage.page.pageLayoutList[k].options.inDocument === item.options.inDocument
              ) {
                const oldRectIds1 = findAllRects(_stage.page.pageLayoutList[k])
                oldRectIds1.forEach(rectId => {
                  const index = _stage.page.children[0].children.findIndex(child => child.rect_id === rectId)
                  if (index > -1) {
                    _stage.page.children[0].children.splice(index, 1)
                  }
                })
                _stage.page.pageLayoutList.splice(k, 1)
              }
            }
            console.log("_stage",_stage)
            if (item.options.inDocument === "header") {
              item.options.isRefHome = true
              item.options.isRefHomeOther = true
              _stage.page.pageLayoutList.unshift(item)
            } else if(item.options.inDocument === "relativeHeader") {
              // 紧跟头部通栏之后
              _stage.page.pageLayoutList.splice(1, 0, item)
            }else if(item.options.inDocument === "headerOther"){
               const relativeHeaderIndex = _stage.page.pageLayoutList.findIndex(item=>item.options.inDocument === "relativeHeader")
              if(relativeHeaderIndex>1){
                _stage.page.pageLayoutList.splice(relativeHeaderIndex+1, 0, item)
              }else{
                _stage.page.pageLayoutList.splice(1, 0, item)
              }
               // const generalPageLayoutIndex = _stage.page.pageLayoutList.findIndex(item=>item.options.inDocument === "none")
               // if(generalPageLayoutIndex>1){
               //   _stage.page.pageLayoutList.splice(generalPageLayoutIndex, 0, item)
               // }else{
               //   _stage.page.pageLayoutList.splice(_stage.page.pageLayoutList.length-1, 0, item)
               // }
            }else{
              _stage.page.pageLayoutList.push(item)
            }
          }
        }
      })
    }
    if (homeStage.page.isOnlyH5Template) {
      _stage.page.isOnlyH5Template = true
    }
    if (homeStage.page.isPhoneFullScreen) {
      _stage.page.isPhoneFullScreen = true
    }
    if (homeStage.page.themeColor) {
      _stage.page.themeColor = homeStage.page.themeColor
    }
    if (homeStage.page.pageWidth) {
      _stage.page.pageWidth = homeStage.page.pageWidth
    }
    if (!_stage.page.hasOwnProperty("isShowFooter")) {
      _stage.page.isShowFooter = homeStage.page.isShowFooter
    }
    if (!_stage.page.hasOwnProperty("isShowHeader")) {
      _stage.page.isShowHeader = homeStage.page.isShowHeader
    }
    if (_stage.page.pageLayoutList?.length > 0) {
      _stage.page.pageLayoutList.forEach(item => {
        if (item.options.inDocument === "header") {
          _stage.page.isShowHeader = item.options.isShow
        }
        if (item.options.inDocument === "footer") {
          _stage.page.isShowFooter = item.options.isShow
        }
      })
    }
  }
  if (_stage.type === "detailPage") {
    // 明杰提示  此处不用掉这个接口 该功能已经挪到 detail接口中
    // const dataLimit = await getDataLimit(engineInstanceId, dataId)
    // if (dataLimit?.data?.code == "0") {
    //   const referer = window.location.href
    //   const loginurl =
    //     window.location.protocol + "//" + window.location.hostname + "/login?referer=" + encodeURIComponent(referer)
    //   const permissonurl = window.location.protocol + "//" + window.location.hostname + "/error/page/no-permisson"
    //   if (dataLimit?.data?.data?.type == "1") {
    //     // 跳转ip提示页
    //     window.location.href = permissonurl
    //   } else if (dataLimit?.data?.data?.type == "2") {
    //     // 跳转登录页
    //     window.location.href = loginurl
    //   }
    //   return
    // }
    let detailExtralShow = false
    try {
      const restClassify = await api.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: homePageId
      })
      if (restClassify?.data?.code === 1) {
        // 获取活动字段
        const { custShow } = restClassify?.data?.data?.engineInstance
        detailExtralShow = custShow && custShow.length > 1 && custShow.charAt(1) === "1" ? true : false
      }
    } catch (error) {

    }
    // 需要捕获下错误，否则没有详情数据时，会阻断
    try {
      // 需要调用获取详情页数据的接口
      let detailPageData = {}
      detailPageData = await getDetailPageData(engineInstanceId, typeId, dataId)
      if (detailPageData.data.data) {
        const _result = [detailPageData.data.data]
        const pageType = _result[0].pageType
        Object.keys(_result).forEach(key => {
          Object.keys(_result[key]).forEach(dataItemKey => {
            // 保留content
            if (dataItemKey === "content" || dataItemKey === "formId" || dataItemKey === "id" || dataItemKey === "videoCoverUrl" || dataItemKey ==="videoObjectId") return
            if (dataItemKey === "viewNum" || dataItemKey === "publisher" || dataItemKey === "updateTime" || (detailExtralShow && dataItemKey === "detailExtral") || dataItemKey === "topUrl") {
              const componentShape = ["cxText", "cxButton"]
              let str = {}
              str.componentShape = componentShape
              str.value = "" + _result[key][dataItemKey]
              if (dataItemKey === "viewNum") str.key = "浏览量"
              if (dataItemKey === "publisher") str.key = "发布者"
              if (dataItemKey === "updateTime") str.key = "修改时间"
              if (dataItemKey === "detailExtral") {
                str.key = "活动字段"
                let value = _result[key][dataItemKey]?.split("![]!")?.join("&nbsp;&nbsp;")
                value = value?.replaceAll(":", "：")
                str.value = value
              }
              if (dataItemKey === "topUrl") str.key = "广告图"
              _result[key][dataItemKey] = str
              return
            }
            if (dataItemKey === "appName" || dataItemKey === "name") {
              if (_result[key][dataItemKey]) {
                window.localStorage.setItem("appName", getHtmlPlainText(_result[key][dataItemKey]))
                document.title = _result[key][dataItemKey]
              }
              const componentShape = ["cxText", "cxButton"]
              let str = {}
              str.componentShape = componentShape
              str.value = "" + _result[key][dataItemKey] || "图文"
              str.key = "应用名称"
              _result[key][dataItemKey] = str
              return
            }
            if (dataItemKey === "graphicImgUrls") {
              if (pageType === 12 && _result[key][dataItemKey]) {
                const arr = _result[key][dataItemKey].split(",")
                _result[key].graphicImgUrls = arr.map(item => {
                  const [desc, src] = item.split("###")
                  return {
                    desc,
                    src
                  }
                })
              } else {
                _result[key].graphicImgUrls = []
              }
              return
            }
            if (isNaN(dataItemKey)) {
              if (dataItemKey !== "previousData" && dataItemKey !== "nextData") delete _result[key][dataItemKey]
            } else {
              if (isFieldAllEmpty(_result, dataItemKey) && _result[key][dataItemKey].key !== "多图轮播") {
                delete _result[key][dataItemKey]
              } else {
                const componentShape = fixComponent(dataItemKey, _result[key][dataItemKey].value)
                _result[key][dataItemKey].component_shape = componentShape
              }
            }
          })
        })
        window.localStorage.setItem("detailData", JSON.stringify(_result))
      }
    } catch (e) {}
  }
  if ((_stage.type === "listPage" || _stage.type === "detailPage") && _stage.page) {
    const hasPreComponet = _stage.page.children[0].children.find(item => item.preComponent)
    if (!hasPreComponet) {
      let component = _stage.type === "listPage" ? ["emptyLayoutComponent"] : []
      _stage.page.children[0].children.forEach(item => {
        // 业务组件都要增加预设标识，不允许删除
        if (
          component.includes(
            item.shape
          ) || item?.options?.type === "prev" || item?.options?.type === "next"
        ) {
          item.preComponent = true
        }
      })
    }
  }
  return _stage
}

/**
 * 替换动画的rectid为最新的
 * @param {*} rect
 * @param {*} oldRectId
 * @param {*} newRectId
 */
function changeRectInAnimation(rect, oldRectId, newRectId) {
  const animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  animateTypes.forEach(type => {
    (rect.options[type] || []).forEach(animation => {
      if(animation.controlIds.rect_id === oldRectId) {
        animation.controlIds.rect_id = newRectId
      }
      if(animation.ids.rect_id === oldRectId) {
        animation.ids.rect_id = newRectId
      }
      animation.passiveIds.forEach(passive => {
        if(passive.rect_id === oldRectId) {
          passive.rect_id = newRectId
        }
      })
    })
  })
}

// 根据appId获取当前应用的子页面设置项
function getSubPageData(appId, homePageData) {
  let subPage = null
  const temp = homePageData.page.subPages?.filter(item => item.appId === appId)
  if (!!temp) {
    subPage = temp[0]
  }
  console.log("subPagesubPagesubPage", subPage)
  return subPage
}

// 当前为移动端 判断是否自动同步
export function judgeSyncData() {
  let stage = store.state.appStage
  // 单纯的移动端 不需要同步数据
  if (stage.page.hasOwnProperty("isPcSyncApp") && stage.page.isPcSyncApp) {
    // 已经同步过（包括手动同步），边部自动同步
    return
  }
  if ((stage.type === "listPage" || stage.type === "detailPage") && stage) {
    // 说明是子页面的移动端
    return
  }
  let createTime = sessionStorage.getItem("createTime")
  sessionStorage?.removeItem("createTime")
  createTime = createTime.split(" ")
  let createTime1 = createTime[0].split("-")
  let createTime2 = createTime[1].split(":")
  let createTimeArr = createTime1.concat(createTime2)
  let nowDate = [2022, 12, 27]
  let pageIsNew = false
  // -2 是省掉分和秒
  for (let j = 0; j < nowDate.length; j++) {
    if (createTimeArr[j] > nowDate[j]) {
      pageIsNew = true
      break
    }
  }
  // 2022-12-28 之前的模版不处理
  if (!pageIsNew) {
    return
  }
  syncBtnData(stage)
}

function syncBtnData(stage) {
  // 先判断是否是独立的移动端 并且是都已经同步过
  if (stage.page.isPhoneFullScreen || stage.page.isOnlyH5Template) {
    return
  }
  // 不是独立的移动端则需要将pc端的数据 同步到移动端
  let data = JSON.parse(JSON.stringify(store.state.stage))
  data.page.isPcSyncApp = true // 做为是否从pc同步过数据的表示

  if (data.page.subPages) {
    // 只有首页才有subPages
    const subPages = JSON.parse(JSON.stringify(data.page.subPages))
    store.dispatch("appStage/changeSubPageMapping", subPages)
  }

  const isShowHeader = store.state.stage.page.isShowHeader
  const isShowFooter = store.state.stage.page.isShowFooter
  //  把PC端头部和底部的显示状态同步过去
  event.initAppStageEvent()
  store.dispatch("appStage/changeAttribute", { option_name: "isShowHeader", option_val: isShowHeader })
  store.dispatch("appStage/changeAttribute", { option_name: "isShowFooter", option_val: isShowFooter })
  setTimeout(() => {
    store.dispatch("appStage/initData", { data })
  }, 500)
}

// 根据rectId找到对应的rect
function getComponentByRectId(stage, rectId) {
  for (let i in stage.page.children[0].children) {
    if (stage.page.children[0].children[i].rect_id === rectId) {
      return stage.page.children[0].children[i]
    }
  }
}

// 获取用户的权限（是否具有上传样式到系统/删除系统样式）
function initUserRole() {
  api.getPermissionList().then(res => {
    //判断是否有模板
    if (res.data.code === 1) {
      let code = []
      let newData = res.data.data
      if (newData && Array.isArray(newData)) {
        res.data.data.forEach(item => {
          code.push(item.role)
        })
      } else {
        // 明杰反馈之前的权限有点乱，所以对权限重新梳理
        if (res.data.data.a) {
          code.push(11)
        }
        if (res.data.data.d) {
          code.push(12)
        }
      }
      store.commit("states/updateUserPermissionCode", [...code])
    }
  })
}

// 获取页面cookie
export async function initGetCookie() {
  let myCookie = await getCookie("UID,current_page_id,website_id,website_fid,fid,webIdEnc,SUID")
  store.commit("states/updateMyCookie", myCookie)
}

export function GetRequest() {
  var url = window.previewUrl || location.href //获取url中"?"符后的字串
  var theRequest = new Object()
  if (url.indexOf("?") != -1) {
    var str = url.split("?")[1]
    var strs = str.split("&")
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
    }
  }
  return theRequest
}

/**
 * 获取page数据
 * @param homePageId
 * @param type
 * @param flag // 6、获取头底+subPages的数据
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function getPageData(homePageId, type, flag, t) {
  return instance.get(
    `v2/webjson/edit/${homePageId}/content?a=${type}` +
      (t !== null && t !== undefined ? `&t=${t}` : "") +
      (flag !== null && flag !== undefined ? `&type=${flag}` : "")
  )
}

/**
 * 需要调用获取详情页数据的接口
 * @param engineInstanceId
 * @param typeId
 * @param dataId
 * @returns {Promise<AxiosResponse<any>>}
 */
async function getDetailPageData(engineInstanceId, typeId, dataId) {
  return api.queryDetailData({
    e: engineInstanceId,
    t: typeId,
    d: dataId,
    param: {
      nc: 1,
      np: 1
    }
  })
}

/**
 * 非外接数据源请求数据集合接口all-request
 * @param pageId
 * @param websiteId
 * @param isMobile
 */
export function getNoneExternalDataSource(pageId, websiteId, isMobile, version) {
  asyncTask.initAllReq(instance.get(`v2/${pageId}/all-request?w=${websiteId}&m=${isMobile}&v=${version}`))
}
/**
 * 判断详情页列表页访问权限
 * @param publicId
 * @param dataId
 */
export async function getDataLimit(publicId, dataId) {
  return api.getDetailPagePermission({
    publicId: publicId,
    dataId: dataId,
    t: 0
  })
}

/**
 * 获取子页面系统模板
 * @param {*} data
 * @returns
 */
export const getSubTemplateContent = data => {
  return instance.get(`v2/module-content/${data}/get?&all=true`)
}


export const getRobotList = () => {
  return instance.get(`v2/robot-list`)
}



export async function parsePageData(pageId, stageType) {
  const res = await getPageData(pageId, stageType, undefined, 7)
  const data = res.data.data
  const webJsonRel = data?.webJsonRel
  let stage = JSON.parse(data?.content)
  if (stage.hasOwnProperty("data") && stage.hasOwnProperty("templates")) {
    // 如果没有version属性，说明是新数据，需要进行解密
    stage = jsonCompressEncode(stage)
  }
  if (webJsonRel?.subPages && webJsonRel.subPages != "[]" && stageType == 0) {
    // 如果在外面取到了subPages，则还原回stage.page.subPages里面去
    stage.page &&
      (stage.page.subPages = (stage.page.subPages || []).concat(JSON.parse(webJsonRel.subPages).map(item =>
        decrypt(JSON.stringify(item), data_dictionary_map)
      )))
  }
  if (webJsonRel?.appSubPages && stageType == 1) {
    // 如果在外面取到了subPages，则还原回stage.page.subPages里面去
    stage.page &&
      (stage.page.subPages = (stage.page.subPages || []).concat(JSON.parse(webJsonRel.appSubPages).map(item =>
        decrypt(JSON.stringify(item), data_dictionary_map)
      )))
  }
  if (!stage?.page?.subPages) {
    // 如果处理完了之后stage.page.subPages还是个undefined，此时需要把属性补个空数组回去，不然在后续逻辑会报错
    stage.page && (stage.page.subPages = [])
  }
  parseInt(stage.version)
  stage = decrypt(JSON.stringify(stage), data_dictionary_map)
  reverseBuildModelForApp(stage)
  stage.page.pageLayoutList[0].options.isRefHome = true
  return stage
}

/**
 * 判断是否是移动端
 * @param pageId
 */
export async function judgeIsMobile(pageId) {
  return instance.get(`v2/page/is-mobile/${pageId}`)
}
